import { useState } from 'react';

export const useCopyToClipboard = () => {
  const [copyTooltip, setCopyTooltip] = useState<string>('Copy Link');

  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyTooltip('Copied!');

        setTimeout(() => {
          // Reset tooltip text after 2 seconds
          setCopyTooltip('Copy Link');
        }, 2000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  };

  return {
    copyTooltip,
    copyToClipboard,
  };
};
